import { Console } from "console";

// utils/defaultRoute.ts
export const getDefaultRoute = (allowedInterfaces: string[] = []): string => {
    if (!allowedInterfaces || allowedInterfaces.length === 0) return '/introuvable';

    debugger;
    console.log('Allowed interfaces:', allowedInterfaces);

    // Check in priority order (adjust if needed)
    if (allowedInterfaces.includes('vendeur')) return '/vendeur';
    if (allowedInterfaces.includes('stock')) return '/preparation';
    if (allowedInterfaces.includes('caisse')) return '/caisse';
    if (allowedInterfaces.includes('commandes')) return '/commandes';
    // Fallback
    return `/${allowedInterfaces[0]}`;
};
